"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFacetecError = exports.resetAuthenticationInProgress = exports.hideQrAuth = exports.showQrAuth = exports.faceTecEnrollmentFailed = exports.faceTecAuthenticationFailed = exports.resetFaceTecAuth = exports.setFacetecDatabaseReference = exports.enrollmentCompleted = exports.startEnrollment = exports.authenticateFaceTec = exports.faceTecAuthenticated = exports.setFacetecSDKReady = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    facetecSDKReady: false,
    loginAuthenticated: false,
    enrolled: false,
    facetecDatabaseReference: null,
    authenticationInProgress: false,
    enrollmentInProgress: false,
    showQrAuthModal: false,
    facetecError: null,
};
const slice = (0, toolkit_1.createSlice)({
    name: "ui",
    initialState,
    reducers: {
        setFacetecSDKReady: (state, action) => {
            state.facetecSDKReady = action.payload;
        },
        faceTecAuthenticated: (state) => {
            state.loginAuthenticated = true;
            state.authenticationInProgress = false;
        },
        authenticateFaceTec: (state) => {
            state.authenticationInProgress = true;
            state.facetecError = null;
        },
        startEnrollment: (state) => {
            state.enrollmentInProgress = true;
            state.facetecError = null;
        },
        enrollmentCompleted: (state) => {
            state.enrolled = true;
            state.enrollmentInProgress = false;
            state.loginAuthenticated = true; // Auto-authenticate after enrollment
        },
        setFacetecDatabaseReference: (state, action) => {
            state.facetecDatabaseReference = action.payload;
        },
        resetFaceTecAuth: (state) => {
            state.loginAuthenticated = false;
            state.enrolled = false;
            state.facetecDatabaseReference = null;
            state.authenticationInProgress = false;
            state.enrollmentInProgress = false;
            state.facetecError = null;
        },
        clearFacetecError: (state) => {
            state.facetecError = null;
        },
        faceTecAuthenticationFailed: (state, action) => {
            state.authenticationInProgress = false;
            state.facetecError = action.payload || "Face authentication failed. Please try again.";
        },
        faceTecEnrollmentFailed: (state, action) => {
            state.enrollmentInProgress = false;
            state.facetecError = action.payload || "Facial Recognition enrolment failed. Please try again.";
        },
        showQrAuth: (state) => {
            state.showQrAuthModal = true;
        },
        hideQrAuth: (state) => {
            state.showQrAuthModal = false;
        },
        resetAuthenticationInProgress: (state) => {
            state.authenticationInProgress = false;
        },
    },
});
_a = slice.actions, exports.setFacetecSDKReady = _a.setFacetecSDKReady, exports.faceTecAuthenticated = _a.faceTecAuthenticated, exports.authenticateFaceTec = _a.authenticateFaceTec, exports.startEnrollment = _a.startEnrollment, exports.enrollmentCompleted = _a.enrollmentCompleted, exports.setFacetecDatabaseReference = _a.setFacetecDatabaseReference, exports.resetFaceTecAuth = _a.resetFaceTecAuth, exports.faceTecAuthenticationFailed = _a.faceTecAuthenticationFailed, exports.faceTecEnrollmentFailed = _a.faceTecEnrollmentFailed, exports.showQrAuth = _a.showQrAuth, exports.hideQrAuth = _a.hideQrAuth, exports.resetAuthenticationInProgress = _a.resetAuthenticationInProgress, exports.clearFacetecError = _a.clearFacetecError;
exports.default = slice.reducer;
